import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHidePack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (packId: number) => {
      return apiMutation('POST', {
        path: ENDPOINTS.hidePack,
        params: { packId: packId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, packId) => {
      message.success(`Package #${packId} hidden`);
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.packs],
        exact: false,
      });
    },
    onError: (_, packId) => {
      message.error(`Error while modifying package #${packId}`);
    },
  });
}
